import React from 'react';
import { isOrganiser } from 'venuescanner-js/constants/user_type';
import OrganiserEnquiryDetails from './OrganiserEnquiryDetails';
import HostEnquiryDetails from './HostEnquiryDetails';

const EnquiryDetailsContainer = ({ can, send, state, status }) => {
  const { thread } = state.context;

  return isOrganiser(thread) ? (
    <OrganiserEnquiryDetails can={can} send={send} state={state} />
  ) : (
    <HostEnquiryDetails status={status} can={can} send={send} state={state} />
  );
};
export default EnquiryDetailsContainer;
